const MultiLineSkeletonLoader = ({
  lines = 3,
  lineHeight = "16px",
  spacing = "12px",
  widths = ["100%", "85%", "60%"],
  className = "",
}) => {
  return (
    <div className={`multiline-skeleton-container ${className}`}>
      {Array.from({ length: lines }).map((_, index) => (
        <div
          key={index}
          className="skeleton-multiline"
          style={{
            width: widths[index] || widths[widths.length - 1] || "100%",
            height: lineHeight,
            marginBottom: index < lines - 1 ? spacing : "0",
            animationDelay: `${index * 0.2}s`,
          }}
        >
          <div
            className="skeleton-multiline-shimmer"
            style={{
              animationDelay: `${index * 0.3}s`,
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default MultiLineSkeletonLoader;
